import { useSearchParams, useParams } from "react-router-dom";
import CreateAdForm from "../components/CreateAdForm";

export default function CreateAdPage() {
  const [sp] = useSearchParams();
  const { categoryId } = useParams();

  const copyFrom = sp.get("copyFrom");
  const copyFromId = copyFrom ? Number(copyFrom) : null;

  // строкой, чтобы совпадало с тем, как вы храните id в стейте
  const initialCategoryId = categoryId ? String(categoryId) : null;

  return (
    <CreateAdForm
      copyFromId={copyFromId}
      initialCategoryId={initialCategoryId}
    />
  );
}